import {
  GUARANTEE,
  GUARANTEE_AND_PARTICIPATION,
  NO_APPROVAL,
  PARTICIPATION
} from "../../data/guaranteeInterestOptions";

// gurantee decision options
export const GUARANTEE_DECISION__GUARANTEE = GUARANTEE;
export const GUARANTEE_DECISION__PARTICIPATION = PARTICIPATION;
export const GUARANTEE_DECISION__GUARANTEE_AND_PARTICIPATION = GUARANTEE_AND_PARTICIPATION;
export const GUARANTEE_DECISION__NO_APPROVAL = NO_APPROVAL;

// creator feedback
export const CREATOR_FEEDBACK = "creator_feedback";
export const CREATOR_FEEDBACK_DETAILS = "creator_feedback_details";
